var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.bannerList)?_c('div',{staticClass:"block-banners"},_vm._l((_vm.bannerList),function(item,idx){return _c('div',{key:("" + idx),staticClass:"item-block",class:{
      'large-banner': item.type === _vm.bannerType.largeBanner,
    },on:{"click":function($event){_vm.onBannerClick(idx)}}},[(!!item.extend_body && item.extend_body.length > 0)?_c('span',{staticClass:"extend-body",domProps:{"innerHTML":_vm._s(item.extend_body)}}):_c('img',{attrs:{"src":item.img_url,"alt":item.memo}})])}),0):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67792032","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/Products/partials/BannerBlock.vue
// module id = null
// module chunks = 